// Add a consistent user ID generator
export function generateUserId(): string {
  // Use a consistent user ID for the session
  if (typeof window !== 'undefined') {
    let userId = localStorage.getItem('dify-user-id');
    if (!userId) {
      userId = `user-${Math.random().toString(36).substring(7)}`;
      localStorage.setItem('dify-user-id', userId);
    }
    return userId;
  }
  // Fallback for server-side rendering or environments without localStorage
  return `user-server-${Math.random().toString(36).substring(7)}`;
}

// Add other general utility functions if needed, e.g., date formatting
export function formatTimestamp(timestamp: Date): string {
  return new Date(timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
} 